import { createColumnHelper } from "@tanstack/react-table";
import { useContext } from "react";
import { Link, NavigateFunction, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { Pegawai } from "../../context/SelectedPegawai";
import {
  capitalizeEachWord,
  capitalizeFirst,
} from "../../helpers/StringHelper";
import { calculateAge } from "../../helpers/usiaHelper";

export type Item = {
  no: number;
  nama: string;
  usia: number;
  jabatan: string;
  tanggal: string;
  detail: string;
  action_id: number;
  action: () => void;
};
type PegawaiResponse = {
  id: number;
  nama: string;
  tgl_lahir: string;
  privilege: string; //harus diberi jabatan
  tgl_masuk_pertama: string;
};

const columnHelper = createColumnHelper<Item>();
export const columns = [
  columnHelper.accessor("no", {
    header: () => "No.",
    cell: (info) => info.getValue(),
    footer: (info) => info.column.id,
  }),

  columnHelper.accessor((row) => row.nama, {
    id: "nama",
    cell: (info) => <>{capitalizeEachWord(info.getValue(), "_")}</>,
    header: () => <span>Nama</span>,
    footer: (info) => info.column.id,
  }),

  columnHelper.accessor("action_id", {
    header: "Action",
    cell: (inf) => (
      <Button
        size="small"
        text="Input Absen"
        onClick={() => {
          inf.row.original.action();
        }}
      />
    ),
    footer: (info) => info.column.id,
  }),
];

export function constructItemFromResponse(
  data_response: PegawaiResponse[],
  navigate: NavigateFunction,
  setPegawai: React.Dispatch<Pegawai | undefined>,
  currentPage: number,
  itemsPerPage: number
) {
  const newItems: Item[] = [];
  data_response.forEach((data: PegawaiResponse, key: number) => {
    const itemNo = (currentPage - 1) * itemsPerPage + key + 1;
    const item: Item = {
      no: itemNo,
      nama: data.nama,
      usia: data.tgl_lahir === undefined ? 0 : calculateAge(data.tgl_lahir),
      jabatan: capitalizeFirst("pegawai"),
      tanggal: data.tgl_masuk_pertama,
      detail: "TEST",
      action_id: data.id,
      action: () => {
        setPegawai({
          id: data.id.toString(),
          name: data.nama,
        });
        navigate("/dashboard/absensi/inputabsensidetail");
      },
    };
    newItems.push(item);
  });
  return newItems;
}
